import moment from "moment-timezone";

export function getLocalTime(dateTime) {
  if (!dateTime) return '';

  const localTime = moment.utc(dateTime).local();
  const timezoneAbbr = localTime.tz(moment.tz.guess()).zoneAbbr();
  return localTime.format(`YYYY-MM-DD HH:mm:ss [${timezoneAbbr}]`);
};